
import CMS, * as CMSConstants from './CMS';
import Restrictions from './Restrictions';
import TaggingController from './Tagging';
import ChatController from './Chat';
import Analytics from './Analytics/Base';

import Fmt_player_Configuration from './fmt-player/Configuration';
// import Fmt_player_PostMessagesHandler from './fmt-player/PostMessagesHandler';    // TODO REVIEW
// import Fmt_player_QueryStringsHandler from './fmt-player/QueryStrings';           // TODO REVIEW
// import Fmt_3_player_ContentHandler from './fmt-player/Content';                   // TODO REVIEW

import Custom_3_player_Configuration from './custom-3-player/Configuration';
import Custom_3_player_PostMessagesHandler from './custom-3-player/PostMessages';
import Custom_3_player_QueryStringsHandler from './custom-3-player/QueryStrings';
import Custom_3_player_ContentHandler from './custom-3-player/Content';

import Custom_4_player_Configuration from './custom-4-player/Configuration';

import Bradmax_player_Configuration from './Bradmax/Configuration';

import THEOplayer_player_Configuration from './THEOplayer-player/Configuration';
// import THEOplayer_player_PostMessagesHandler from './THEOplayer-player/PostMessages';  // TODO REVIEW
// import THEOplayer_player_QueryStringsHandler from './THEOplayer-player/QueryStrings';  // TODO REVIEW
// import THEOplayer_player_ContentHandler from './THEOplayer-player/Content';            // TODO REVIEW

import Call from '../helpers/Network/Json';

import ExternalConfiguration from '../external-configuration';

import Wrapper_THEOplayer from '../components/Wrapper-THEOplayer/Wrapper-THEOplayer';
import Wrapper_custom_3_player from '../components/Wrapper-custom-3-player/Wrapper-custom-3-player';
import Wrapper_custom_3_plain_player from '../components/Wrapper-custom-3-plain-player/Wrapper-custom-3-plain-player';
import Wrapper_custom_3_s73_player from '../components/Wrapper-custom-3-s73-player/Wrapper-custom-3-s73-player';
import Wrapper_custom_4_player from '../components/Wrapper-custom-4-player/Wrapper-custom-4-player';
import Wrapper_Bradmax_player from '../components/Wrapper-Bradmax/Wrapper-Bradmax';
import Wrapper_Bradmax_player_s3 from '../components/Wrapper-Bradmax-s73/Wrapper-Bradmax-s73';
import Wrapper_v_fmt_player from '../components/Wrapper-v-fmt-player/Wrapper-v-fmt-player';

export const States = {
  Loading: 'Loading',
  Loaded: 'Loaded',
};

export const Layouts = {
  Main: 'Main',
  WithChat: 'WithChat',
  WithTagging: 'WithTagging',
};

export const SrcTypes = {
  Vod: 'Vod',
  Live: 'Live',
};

export const PlayerComponentKeys = {
  Wrapper_v_fmt_player: 'Wrapper_v_fmt_player',
  Wrapper_custom_3_player: 'Wrapper_custom_3_player',
  Wrapper_custom_3_plain_player: 'Wrapper_custom_3_plain_player',
  Wrapper_custom_3_s73_player: 'Wrapper_custom_3_s73_player',
  Wrapper_custom_4_player: 'Wrapper_custom_4_player',
  Wrapper_Bradmax: 'Wrapper_Bradmax',
  Wrapper_Bradmax_s73: 'Wrapper_Bradmax_s73',
  Wrapper_THEOplayer: 'Wrapper_THEOplayer',
};

const PlayerComponents = {
  [PlayerComponentKeys.Wrapper_v_fmt_player]: {
    processConfiguration: Fmt_player_Configuration.processConfiguration,
    render: props => <Wrapper_v_fmt_player {...props}/>,
    specificQueryStringsHandler: null,
    specificPostMessagesHandler: null,
    specificContentHandler: null,
  },
  [PlayerComponentKeys.Wrapper_custom_3_player]: {
    processConfiguration: Custom_3_player_Configuration.processConfiguration,
    render: props => <Wrapper_custom_3_player {...props}/>,
    specificQueryStringsHandler: Custom_3_player_QueryStringsHandler,
    specificPostMessagesHandler: Custom_3_player_PostMessagesHandler,
    specificContentHandler: Custom_3_player_ContentHandler,
  },
  [PlayerComponentKeys.Wrapper_custom_3_plain_player]: {
    processConfiguration: Custom_3_player_Configuration.processConfiguration,
    render: props => <Wrapper_custom_3_plain_player {...props}/>,
    specificQueryStringsHandler: Custom_3_player_QueryStringsHandler,
    specificPostMessagesHandler: Custom_3_player_PostMessagesHandler,
    specificContentHandler: Custom_3_player_ContentHandler,
  },
  [PlayerComponentKeys.Wrapper_custom_3_s73_player]: {
    processConfiguration: Custom_3_player_Configuration.processConfiguration,
    render: props => <Wrapper_custom_3_s73_player {...props}/>,
    specificQueryStringsHandler: Custom_3_player_QueryStringsHandler,
    specificPostMessagesHandler: Custom_3_player_PostMessagesHandler,
    specificContentHandler: Custom_3_player_ContentHandler,
  },
  [PlayerComponentKeys.Wrapper_custom_4_player]: {
    processConfiguration: Custom_4_player_Configuration.processConfiguration,
    render: props => <Wrapper_custom_4_player {...props}/>,
    specificQueryStringsHandler: null, // Custom_4_player_QueryStringsHandler,
    specificPostMessagesHandler: null, // Custom_4_player_PostMessagesHandler,
    specificContentHandler: null, // Custom_4_player_ContentHandler,
  },
  [PlayerComponentKeys.Wrapper_Bradmax]: {
    processConfiguration: Bradmax_player_Configuration.processConfiguration,
    render: props => <Wrapper_Bradmax_player {...props}/>,
    specificQueryStringsHandler: null, // Bradmax_QueryStringsHandler,
    specificPostMessagesHandler: null, // Bradmax_PostMessagesHandler,
    specificContentHandler: null, // Bradmax_ContentHandler,
  },
  [PlayerComponentKeys.Wrapper_Bradmax_s73]: {
    processConfiguration: Bradmax_player_Configuration.processConfiguration,
    render: props => <Wrapper_Bradmax_player_s3 {...props}/>,
    specificQueryStringsHandler: null, // Bradmax_QueryStringsHandler,
    specificPostMessagesHandler: null, // Bradmax_PostMessagesHandler,
    specificContentHandler: null, // Bradmax_ContentHandler,
  },
  [PlayerComponentKeys.Wrapper_THEOplayer]: {
    processConfiguration: THEOplayer_player_Configuration.processConfiguration,
    render: props => <Wrapper_THEOplayer {...props}/>,
    specificQueryStringsHandler: null,
    specificPostMessagesHandler: null,
    specificContentHandler: null,
  },
};

const processConfiguration = (loadedConfiguration = {}) => {

  const PlayerComponentKey = PlayerComponentKeys[ loadedConfiguration?.PlayerComponentKey ] ?? PlayerComponentKeys.Wrapper_custom_3_player;
  // const PlayerComponentKey = PlayerComponentKeys[ loadedConfiguration?.PlayerComponentKey ] ?? PlayerComponentKeys.Wrapper_custom_3_s73_player;
  // const PlayerComponentKey = PlayerComponentKeys[ loadedConfiguration?.PlayerComponentKey ] ?? PlayerComponentKeys.Wrapper_Bradmax;
  // const PlayerComponentKey = PlayerComponentKeys[ loadedConfiguration?.PlayerComponentKey ] ?? PlayerComponentKeys.Wrapper_Bradmax_s73;

  const PlayerComponent = PlayerComponents[ PlayerComponentKey ];

  const { fmt_playerConfiguration, custom_3_playerConfiguration, theoplayer_playerConfiguration, contentData, auxiliarData } = PlayerComponent.processConfiguration( loadedConfiguration);
  auxiliarData.iframeId = loadedConfiguration.id;
  auxiliarData.platformId = loadedConfiguration.platformId;
  auxiliarData.srcType = auxiliarData.mediaSrcType === CMSConstants.MediaSrcTypes.live ? SrcTypes.Live : SrcTypes.Vod;
  auxiliarData.displayLoading = false;
  // TODO REVIEW setRepetition

  // TODO acciones de content (backup, etc...), programación, startAt, actualización activa, rerender, REVIEW post-messages
  // TODO detectar posibles mixed-content y promocinar a https donde sea necesario (flujo, miniatura, etc...)
  // REVIEW (fmt-player properties) skin, loop, muted, volume, favicon, aspectRatio, startAt, alternateContent, displayTitle, type, (buttons, disables)
  // TODO REVIEW especificamente fmt-player: chromecast / airplay, logo / mosca, compartir y descargar, captions, chapters, specific-queryStrings
  const playbackRestrictions = Restrictions.processConfiguration( loadedConfiguration);
  const taggingConfiguration = TaggingController.processConfiguration( loadedConfiguration, auxiliarData);
  const chatConfiguration = ChatController.processConfiguration( loadedConfiguration, auxiliarData);
  const analyticsConfiguration = Analytics.processConfiguration( loadedConfiguration, contentData, auxiliarData);

  const layoutMain = Layouts.Main;
  const layoutWithTagging = !!taggingConfiguration && Layouts.WithTagging;
  const layoutWithChat = !!chatConfiguration && Layouts.WithChat;

  const layout = layoutWithChat || layoutWithTagging || layoutMain;

  // REVIEW warnings referentes a flash (fmt-player)
  // TODO integrar sistemas de estadisticas de Barcelona y nuevo

  const configuration = {
    PlayerComponent,
    fmt_playerConfiguration,
    custom_3_playerConfiguration,
    theoplayer_playerConfiguration,
    layout,
    analyticsConfiguration,
    chatConfiguration,
    taggingConfiguration,
    playbackRestrictions,
    contentData,
    auxiliarData,
  };
  // console.log( 'controllers::Configuration::processConfiguration() - configuration: ', configuration);   // DEVELOP
  return configuration;
};

const Configuration = {

  currentLoadedConfiguration: null,

  getConfiguration: iframeId => {
    const { PresetConfigurationsPaths } = ExternalConfiguration;
    if( iframeId in PresetConfigurationsPaths) return Call.get( PresetConfigurationsPaths[ iframeId]);
    return CMS.loadConfiguration( iframeId);
  },

  load: async ( iframeId, updateConfigurationCallback) => {
    try {
      const configuration = await Configuration.getConfiguration( iframeId);
      Configuration.currentLoadedConfiguration = JSON.stringify( configuration);
      if( updateConfigurationCallback) updateConfigurationCallback( processConfiguration(configuration), null);
    } catch( error) {
      console.error( error);
      const newError = { message: 'Error cargando la configuración.', baseError: error };
      if( updateConfigurationCallback) updateConfigurationCallback( null, newError);
    }
  },

  testForRefreshConfiguration: async ( iframeId) => {
    const configuration = await Configuration.getConfiguration( iframeId);
    return Configuration.currentLoadedConfiguration !== JSON.stringify( configuration);
  },

};

export default Configuration;
